// @flow
import styled, { css } from 'styled-components';
import { silverGrey, blackGrey } from '../../../colors';
import { InputTheme } from '../../../input';
import ArrowIcon from '../../../icons/arrow';
/*::
import type { Node } from 'react';
import type { InputThemeType } from '../../../input';

export type MultiInputThemeType = {|
  Main: * => Node,
  TextInput: InputThemeType,
  DropdownControl: * => Node,
  OptionsContainer: * => Node,
  MoreNumber: * => Node,
  MoreNumberContainer: * => Node,
  OptionList: InputThemeType,
  Calc: * => Node,
  CalcItem: * => Node,
  ArrowIcon: * => Node,
|};
*/

export var OptionListInputCss = css(["background-color:transparent;border-color:transparent;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:", ";padding-right:2rem;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"], blackGrey());
var DefaultTheme
/*: MultiInputThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "fhg87d-0"
  })(["position:relative;overflow:hidden;padding-bottom:1px;"]),
  TextInput: Object.assign({}, InputTheme, {
    Input: styled(InputTheme.Input).withConfig({
      displayName: "theme__Input",
      componentId: "fhg87d-1"
    })(["[readonly]{cursor:pointer;}"])
  }),
  DropdownControl: styled.div.withConfig({
    displayName: "theme__DropdownControl",
    componentId: "fhg87d-2"
  })(["position:absolute;top:0;right:1rem;display:flex;justify-content:center;align-items:center;width:1rem;height:100%;cursor:pointer;"]),
  OptionsContainer: styled.div.withConfig({
    displayName: "theme__OptionsContainer",
    componentId: "fhg87d-3"
  })(["position:absolute;top:0;left:0;width:100%;pointer-events:none;display:grid;align-items:center;grid-template-columns:1fr 4.5rem;"]),
  OptionList: Object.assign({}, InputTheme, {
    Input: styled(InputTheme.Input).withConfig({
      displayName: "theme__Input",
      componentId: "fhg87d-4"
    })(["", ""], OptionListInputCss)
  }),
  MoreNumberContainer: styled.div.withConfig({
    displayName: "theme__MoreNumberContainer",
    componentId: "fhg87d-5"
  })([""]),
  MoreNumber: styled.div.withConfig({
    displayName: "theme__MoreNumber",
    componentId: "fhg87d-6"
  })(["width:1.5rem;height:1.5rem;background:", ";border-radius:50%;text-align:center;line-height:1.5rem;"], silverGrey()),
  Calc: styled.div.withConfig({
    displayName: "theme__Calc",
    componentId: "fhg87d-7"
  })(["visibility:hidden;position:absolute;top:-10rem;white-space:nowrap;"]),
  CalcItem: styled.span.withConfig({
    displayName: "theme__CalcItem",
    componentId: "fhg87d-8"
  })(["display:inline-block;"]),
  ArrowIcon: styled(ArrowIcon).withConfig({
    displayName: "theme__ArrowIcon",
    componentId: "fhg87d-9"
  })(["transition:all 0.3s;"])
};
export default DefaultTheme;